module.exports = __webpack_public_path__ + "static/media/1f6091.b35a4563.webp";